import ContainerList from "./ContainerList";
import ContainerTableList from "./ContainerTableList";

const ContainerPlanningConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/container-list',
            element: <ContainerList />,
        },
          {
            path: '/table-analysis',
            element: <ContainerTableList />,
        },
    ],
};

export default ContainerPlanningConfig;
